(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zln-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zln-before-after')) {
    customElements.define(
      'zln-before-after',
      class ZlnBeforeAfter extends HTMLElement {
        connectedCallback() {
          this._onPointerDown = this._onPointerDown.bind(this);
          this._onPointerMove = this._onPointerMove.bind(this);
          this._onPointerUp = this._onPointerUp.bind(this);
          this._onKey = this._onKey.bind(this);
          this._onSubmit = this._onSubmit.bind(this);

          this.addEventListener('pointerdown', this._onPointerDown);
          this.addEventListener('keydown', this._onKey);
          this.addEventListener('submit', this._onSubmit);
        }

        disconnectedCallback() {
          window.removeEventListener('pointermove', this._onPointerMove);
          window.removeEventListener('pointerup', this._onPointerUp);
        }

        get frame() { return this.querySelector('.zln-ba__frame'); }

        _clamp(n) { return Math.min(100, Math.max(0, n)); }

        _apply(pct) {
          const f = this.frame;
          if (!f) return;
          pct = this._clamp(pct);
          f.style.setProperty('--pos', pct + '%');
          const h = this.querySelector('.zln-ba__handle');
          if (h) h.setAttribute('aria-valuenow', Math.round(pct));
        }

        _fromX(x) {
          const f = this.frame;
          if (!f) return;
          const r = f.getBoundingClientRect();
          this._apply(((x - r.left) / r.width) * 100);
        }

        _onPointerDown(event) {
          const f = this.frame;
          if (!f || !event.target.closest('.zln-ba__frame')) return;
          if (event.target.closest('.zln-ba__rec')) return;
          this._dragging = true;
          this._fromX(event.clientX);
          window.addEventListener('pointermove', this._onPointerMove);
          window.addEventListener('pointerup', this._onPointerUp);
          event.preventDefault();
        }

        _onPointerMove(event) { if (this._dragging) this._fromX(event.clientX); }

        _onPointerUp() {
          this._dragging = false;
          window.removeEventListener('pointermove', this._onPointerMove);
          window.removeEventListener('pointerup', this._onPointerUp);
        }

        _onKey(event) {
          const handle = event.target.closest('.zln-ba__handle');
          if (!handle) return;
          const cur = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') { this._apply(cur - 2); event.preventDefault(); }
          else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') { this._apply(cur + 2); event.preventDefault(); }
          else if (event.key === 'Home') { this._apply(0); event.preventDefault(); }
          else if (event.key === 'End') { this._apply(100); event.preventDefault(); }
        }

        async _onSubmit(event) {
          const form = event.target.closest('.zln-ba__rec-form');
          if (!form) return;
          event.preventDefault();
          const btn = form.querySelector('button[type="submit"]');
          const idInput = form.querySelector('[name="id"]');
          if (!idInput || !idInput.value) return;
          if (btn) btn.setAttribute('aria-busy', 'true');
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const url = root.replace(/\/$/, '') + '/cart/add.js';
          try {
            const res = await fetch(url, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: new FormData(form)
            });
            if (!res.ok) throw new Error('add failed');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            const drawer = document.querySelector('cart-drawer, cart-drawer-component, [data-cart-drawer]');
            if (drawer) {
              if (typeof drawer.open === 'function') drawer.open();
              else drawer.setAttribute('open', '');
            }
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          } catch (err) {
            form.submit();
          } finally {
            if (btn) btn.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zln-beneficios"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zln-feature-carousel')) {
    customElements.define(
      'zln-feature-carousel',
      class ZlnFeatureCarousel extends HTMLElement {
        connectedCallback() {
          this._reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this._onScroll = this._onScroll.bind(this);
          this._onClick = this._onClick.bind(this);
          this._onEnter = this._pauseAuto.bind(this);
          this._onLeave = this._startAuto.bind(this);
          this._onVisibility = this._onVisibility.bind(this);

          this.addEventListener('click', this._onClick);
          this.addEventListener('mouseenter', this._onEnter);
          this.addEventListener('focusin', this._onEnter);
          this.addEventListener('mouseleave', this._onLeave);
          document.addEventListener('visibilitychange', this._onVisibility);

          const track = this.track;
          if (track) track.addEventListener('scroll', this._onScroll, { passive: true });

          this._setupVideos();
          this._syncNav();
          this._startAuto();
        }

        disconnectedCallback() {
          const track = this.track;
          if (track) track.removeEventListener('scroll', this._onScroll);
          this.removeEventListener('click', this._onClick);
          this.removeEventListener('mouseenter', this._onEnter);
          this.removeEventListener('focusin', this._onEnter);
          this.removeEventListener('mouseleave', this._onLeave);
          document.removeEventListener('visibilitychange', this._onVisibility);
          this._pauseAuto();
          if (this._io) this._io.disconnect();
        }

        get track() { return this.querySelector('.zln-feat__track'); }
        get cards() { return Array.from(this.querySelectorAll('.zln-feat__card')); }
        get dots() { return Array.from(this.querySelectorAll('.zln-feat__dot')); }

        _setupVideos() {
          const vids = Array.from(this.querySelectorAll('video[data-autoplay-in-view]'));
          if (!vids.length || this._reduce) return;
          this._io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const v = entry.target;
                if (entry.isIntersecting && entry.intersectionRatio > 0.4) {
                  v.muted = true;
                  const p = v.play();
                  if (p && p.catch) p.catch(function () {});
                } else {
                  v.pause();
                }
              });
            },
            { threshold: [0, 0.4, 0.75] }
          );
          vids.forEach((v) => this._io.observe(v));
        }

        _onClick(event) {
          const dot = event.target.closest('.zln-feat__dot');
          if (dot) { this._scrollTo(parseInt(dot.dataset.index, 10)); return; }
          const nav = event.target.closest('.zln-feat__nav');
          if (!nav) return;
          const dir = nav.classList.contains('zln-feat__nav--next') ? 1 : -1;
          this._scrollTo(this._activeIndex() + dir);
        }

        _scrollTo(i) {
          const track = this.track;
          const cards = this.cards;
          if (!track || !cards.length) return;
          i = Math.max(0, Math.min(cards.length - 1, i));
          const left = cards[i].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          track.scrollTo({ left: left, behavior: this._reduce ? 'auto' : 'smooth' });
        }

        _activeIndex() {
          const track = this.track;
          const cards = this.cards;
          if (!track || !cards.length) return 0;
          const tl = track.getBoundingClientRect().left;
          let best = 0;
          let dist = Infinity;
          cards.forEach((c, i) => {
            const d = Math.abs(c.getBoundingClientRect().left - tl);
            if (d < dist) { dist = d; best = i; }
          });
          return best;
        }

        _onScroll() {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => {
            this._raf = null;
            this._syncNav();
          });
        }

        _syncNav() {
          const active = this._activeIndex();
          this.dots.forEach((d, i) => {
            if (i === active) d.setAttribute('aria-current', 'true');
            else d.removeAttribute('aria-current');
          });
          const track = this.track;
          if (!track) return;
          const prev = this.querySelector('.zln-feat__nav--prev');
          const next = this.querySelector('.zln-feat__nav--next');
          const max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max;
        }

        _startAuto() {
          if (!this.hasAttribute('data-autoplay') || this._reduce) return;
          this._pauseAuto();
          const speed = parseInt(this.getAttribute('data-autoplay-speed'), 10) || 5000;
          this._timer = setInterval(() => {
            const cards = this.cards;
            const next = this._activeIndex() + 1;
            this._scrollTo(next >= cards.length ? 0 : next);
          }, speed);
        }

        _pauseAuto() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }

        _onVisibility() { if (document.hidden) this._pauseAuto(); else this._startAuto(); }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zln-col-carrusel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zln-coll-carousel')) {
    customElements.define(
      'zln-coll-carousel',
      class ZlnCollCarousel extends HTMLElement {
        connectedCallback() {
          this._reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this._onClick = this._onClick.bind(this);
          this._onScroll = this._onScroll.bind(this);
          this.addEventListener('click', this._onClick);
          const track = this.track;
          if (track) track.addEventListener('scroll', this._onScroll, { passive: true });
          this._syncNav();
        }
        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
          const track = this.track;
          if (track) track.removeEventListener('scroll', this._onScroll);
        }
        get track() { return this.querySelector('.zln-coll__track'); }
        get cards() { return Array.from(this.querySelectorAll('.zln-coll__card')); }
        _onClick(event) {
          const nav = event.target.closest('.zln-coll__nav');
          if (!nav || !this.contains(nav)) return;
          const dir = nav.classList.contains('zln-coll__nav--next') ? 1 : -1;
          this._scrollTo(this._activeIndex() + dir);
        }
        _scrollTo(i) {
          const track = this.track;
          const cards = this.cards;
          if (!track || !cards.length) return;
          i = Math.max(0, Math.min(cards.length - 1, i));
          const left = cards[i].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          track.scrollTo({ left: left, behavior: this._reduce ? 'auto' : 'smooth' });
        }
        _activeIndex() {
          const track = this.track;
          const cards = this.cards;
          if (!track || !cards.length) return 0;
          const tl = track.getBoundingClientRect().left;
          let best = 0;
          let dist = Infinity;
          cards.forEach((c, i) => {
            const d = Math.abs(c.getBoundingClientRect().left - tl);
            if (d < dist) { dist = d; best = i; }
          });
          return best;
        }
        _onScroll() {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => { this._raf = null; this._syncNav(); });
        }
        _syncNav() {
          const track = this.track;
          if (!track) return;
          const prev = this.querySelector('.zln-coll__nav--prev');
          const next = this.querySelector('.zln-coll__nav--next');
          const maxScroll = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= maxScroll;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zln-faqs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class FaqAccordion extends HTMLElement {
        connectedCallback() {
          this.classList.add('is-enhanced');
          this.allowMultiple = this.hasAttribute('data-allow-multiple');

          this._onClick = this._onClick.bind(this);
          this._onBlockSelect = this._onBlockSelect.bind(this);

          this.addEventListener('click', this._onClick);
          document.addEventListener('shopify:block:select', this._onBlockSelect);

          this.querySelectorAll('.faq__item').forEach((item) => {
            const btn = item.querySelector('.faq__question');
            if (btn) {
              btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
            }
          });
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
          document.removeEventListener('shopify:block:select', this._onBlockSelect);
        }

        _onClick(event) {
          const btn = event.target.closest('.faq__question');
          if (!btn || !this.contains(btn)) return;
          const item = btn.closest('.faq__item');
          if (item) this._toggle(item);
        }

        _toggle(item, force) {
          const btn = item.querySelector('.faq__question');
          const willOpen = force !== undefined ? force : !item.classList.contains('is-open');

          if (willOpen && !this.allowMultiple) {
            this.querySelectorAll('.faq__item.is-open').forEach((other) => {
              if (other === item) return;
              other.classList.remove('is-open');
              const ob = other.querySelector('.faq__question');
              if (ob) ob.setAttribute('aria-expanded', 'false');
            });
          }

          item.classList.toggle('is-open', willOpen);
          if (btn) btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        }

        _onBlockSelect(event) {
          const target = event.target && event.target.closest ? event.target.closest('.faq__item') : null;
          if (target && this.contains(target)) this._toggle(target, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
